import { useHistory } from 'react-router-dom'
import { useShop } from 'shop/hooks'
import ErrorModal from 'shop/components/Modal/ErrorModal'

const cartErrorGlossary = (
  errorCode: string,
  storeName: string | null,
  history: any
): {
  title: string
  messages: string[]
  buttonMessage: string
  handleButtonClick: () => void
} => {
  return {
    title: 'Oops, something has gone wrong',
    messages: [
      'We have encountered an unexpected problem. Please go back and try again.'
    ],
    buttonMessage: 'Try again',
    handleButtonClick: () => history.push('/')
  }
}

interface CartErrorModalProps {
  errorCode: string
}

const CartErrorModal = ({ errorCode }: CartErrorModalProps) => {
  const history = useHistory()
  const { currentPartnerStore } = useShop()
  const { name: storeName = '' } = currentPartnerStore || {}

  return (
    <ErrorModal
      errorCode={errorCode}
      errorTitle={cartErrorGlossary(errorCode, storeName, history).title}
      errorMessages={cartErrorGlossary(errorCode, storeName, history).messages}
      primaryButton={{
        message: cartErrorGlossary(errorCode, storeName, history).buttonMessage,
        onClick: cartErrorGlossary(errorCode, storeName, history)
          .handleButtonClick
      }}
    />
  )
}

export default CartErrorModal
